import { HStack, Button, useBoolean, Icon } from '@wegroup/design-system';
import cogoToast from 'cogo-toast';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LicenseInputEU from '../../../../../../common/src/legacy/LicenseInputEU';
import { retrieveVehiclesByNumberPlate } from '../../../../../../common/src/legacy/services/apiRouterService';
import { request } from '../../../../../../common/src/legacy/services/httpSessionService';
import { Car } from '../../../../../../../types/SMT';
import { Inputs } from '../../../../types/Enums';
import { getFlowsDataTestId } from '../../../../utils/testUtils';

interface Props {
  name?: string;
  value: string;
  onChange: (arg0: Car, numberPlate: string) => void;
  isDisabled?: boolean;
}

const NumberPlateInput: React.FC<Props> = ({
  name,
  value,
  isDisabled,
  onChange,
}) => {
  const { t } = useTranslation();

  const [numberPlate, setNumberPlate] = useState<string>(value);
  const [isSearching, setIsSearching] = useBoolean();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNumberPlate(e.target.value);
  };

  const handleClick = async () => {
    setIsSearching.on();
    const trimmedPlate = numberPlate?.trim();

    const [resp, status] = await retrieveVehiclesByNumberPlate(
      trimmedPlate,
      'NL',
    );

    if (status >= 400) {
      cogoToast.error('No car was found');
    } else {
      const [premiumResp, premiumStatus] = await request({
        path: resp.items[0].self,
        method: 'GET',
      });

      if (premiumStatus >= 400) {
        cogoToast.error('No car was found');
      }

      onChange(premiumResp?.domain_car?.car as Car, trimmedPlate);
    }
    setIsSearching.off();
  };

  return (
    <HStack spacing="6">
      <LicenseInputEU
        countryCode="NL"
        onChange={handleChange}
        value={numberPlate}
        isDisabled={isDisabled}
      />
      <Button
        leftIcon={<Icon name="IconSearch" color="currentcolor" />}
        h="12"
        px="6"
        onClick={handleClick}
        isLoading={isSearching}
        data-test-id={getFlowsDataTestId(
          Inputs.NUMBER_PLATE,
          name || '',
          'SEARCH-BUTTON',
        )}
        isDisabled={isDisabled}
      >
        {t('SEARCH')}
      </Button>
    </HStack>
  );
};

export default NumberPlateInput;
